import { useRepositorySuspenseQuery } from '@mews-commander/data-access';

export const useExistingTemplateNames = (currentName?: string) => {
    const { data: contractTemplatesData } = useRepositorySuspenseQuery('reservationContractTemplates', 'getAll', {});
    return (
        contractTemplatesData.templates?.map((template) => template.name).filter((name) => name !== currentName) ?? []
    );
};
